/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AddProfileIcon extends BaseIcon {
    getChildren = () => [
        <g>
            <path fill="none" d="M0 0h84v84H0z"/>
            <g>
                <path d="M58.094 37.102H25.719a1.156 1.156 0 110-2.312h32.375a1.156 1.156 0 110 2.312z" fill={this.getColor()}/>
                <path d="M53.469 46.353h-27.75a1.156 1.156 0 010-2.312h27.75a1.1565 1.1565 0 110 2.313z" fill={this.getColor()}/>
                <path d="M48.844 55.602H25.719a1.156 1.156 0 010-2.312h23.125a1.1565 1.1565 0 010 2.313z" fill={this.getColor()}/>
                <g >
                    <path d="M69.656 50.977a13.875 13.875 0 1013.875 13.875 13.874 13.874 0 00-13.875-13.875z" fill={this.getColor()}/>
                    <g fill="#fff">
                        <path d="M68.83813 55.62638a1.155 1.155 0 011.97424.816v16.81924a1.15718 1.15718 0 01-2.31436.00495V56.43743a1.152 1.152 0 01.34012-.81105z"/>
                        <path d="M60.43063 64.03388a1.152 1.152 0 01.816-.338l16.82066.00141a1.156 1.156 0 010 2.30942l-16.8242.00495a1.155 1.155 0 01-.816-1.97425z"/>
                    </g>
                </g>
                <g fill={this.getColor()}>
                    <path d="M69.656 48.664a1.157 1.157 0 01-1.156-1.156V17.446a1.157 1.157 0 00-1.156-1.156H56.781a1.1565 1.1565 0 010-2.313h10.563a3.473 3.473 0 013.469 3.469v30.062a1.157 1.157 0 01-1.157 1.156z"/>
                    <path d="M55.781 78.727H16.469A3.473 3.473 0 0113 75.258V17.446a3.473 3.473 0 013.469-3.469h10.562a1.1565 1.1565 0 010 2.313H16.469a1.157 1.157 0 00-1.156 1.156v57.812a1.157 1.157 0 001.156 1.156h39.312a1.1565 1.1565 0 010 2.313z"/>
                </g>
                <path d="M41.906 7.04a3.469 3.469 0 11-3.469 3.469 3.473 3.473 0 013.469-3.469m0-2.312a5.781 5.781 0 105.781 5.781 5.78 5.78 0 00-5.781-5.782z" fill={this.getColor()}/>
                <path d="M53.469 20.914H30.344a3.473 3.473 0 01-3.469-3.468v-4.625a3.473 3.473 0 013.469-3.469h6.937a1.156 1.156 0 010 2.312h-6.937a1.157 1.157 0 00-1.156 1.157v4.625a1.157 1.157 0 001.156 1.156h23.125a1.157 1.157 0 001.156-1.156v-4.625a1.157 1.157 0 00-1.156-1.156h-6.36a1.156 1.156 0 110-2.312h6.359a3.473 3.473 0 013.469 3.469v4.625a3.473 3.473 0 01-3.468 3.467z" fill={this.getColor()}/>
            </g>
        </g>
    ]
    getViewBox = () => '0 0 84 84'
}
